import { DELETE_USER, DELETE_USER_SUCCESSFUL, DELETE_USER_FAILED } from './actionTypes';

export const deleteUser = (username, name, token, history) => {
    return {
        type: DELETE_USER,
        payload: { username, name, token, history }
    }
}

export const deleteUserSuccessful = (msg) => {
    return {
        type: DELETE_USER_SUCCESSFUL,
        payload: msg
    }
}

export const deleteUserFailed = (msg) => {
    return {
        type: DELETE_USER_FAILED,
        payload: msg
    }
}
